import { fetchGet, createParamGet } from '../utilities/ServiceUtils';
import * as ApiConstants from '../constants/ApiConstants';
import { isNil } from 'lodash';

const formatParameters = (parameters) => {
    const formattedParameters = { ...parameters };
    Object.keys(parameters).forEach((key) => {
        const value = parameters[key];
        if (parameters[key] instanceof Date) {
            formattedParameters[key] = value.toISOString();
        }
    });
    return createParamGet(formattedParameters);
};

const formatParametersSearchTable = (parameters) => {
    const formattedParameters = { ...parameters };
    Object.keys(parameters).forEach((key) => {
        const value = parameters[key];
        if (parameters[key] instanceof Date) {
            formattedParameters[key] = value.toISOString();
        }
    });
    return createParamSearchTableGet(formattedParameters);
};

const createParamSearchTableGet = (objParam) => {
    let strParam = '';

    Object.keys(objParam).forEach((key) => {
        if (!isNil(objParam[key]) && objParam[key] !== '') {
            if (Array.isArray(objParam[key]) && objParam[key].length > 0) {
                if (strParam === '') {
                    strParam += `${key}=${objParam[key].join(',')}`;
                } else {
                    strParam += `&${key}=${objParam[key].join(',')}`;
                }
            } else {
                if (strParam === '') {
                    strParam += `${key}=${objParam[key]}`;
                } else {
                    strParam += `&${key}=${objParam[key]}`;
                }
            }
        }
    });

    return strParam;
};

export const createEvent = async (parameters) => {
    try {
        const fetchData = await fetch(ApiConstants.SERVICE_EVENT_CREATE_EVENT, {
            method: 'POST',
            body: parameters,
            headers: {
                'Accept-Language': 'th',
                'x-api-key': process.env.REACT_APP_API_KEY,
            },
        });
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error createEvent :: ', error);
    }
};

export const fetchEventById = async (eventId, parameters) => {
    try {
        const fetchData = await fetchGet(
            `${ApiConstants.SERVICE_EVENT_GET_EVENT_BY_ID}?${formatParameters(
                parameters
            )}`.replace(':eventId', eventId)
        );
        if (!fetchData.ok) {
            throw fetchData;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('error fetchEventById :: ', error);
        throw error;
    }
};

export const fetchEventPublicById = async (parameters) => {
    try {
        const { eventId } = parameters;
        const fetchData = await fetchGet(
            ApiConstants.SERVICE_EVENT_GET_EVENT_BY_ID.replace(
                ':eventId',
                eventId
            )
        );
        if (!fetchData.ok) {
            throw fetchData;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('error fetchEventById :: ', error);
        throw error;
    }
};

export const fetchEventSearch = async (parameters, userId) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_EVENT_GET_EVENT_SEARCH
            }?${formatParametersSearchTable(parameters)}`.replace(
                ':userId',
                userId
            )
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('ex fetchEventSearch : ', error);
    }
};

export const updateEvent = async (parameters, eventId) => {
    try {
        const fetchData = await fetch(
            ApiConstants.SERVICE_EVENT_UPDATE_EVENT.replace(
                ':eventId',
                eventId
            ),
            {
                method: 'PUT',
                body: parameters,
                headers: {
                    'Accept-Language': 'th',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
            }
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error updateEvent :: ', error);
    }
};

export const getLookupInternalUser = async () => {
    try {
        const fetchData = await fetchGet(
            `${ApiConstants.SERVICE_EVENT_GET_LOOKUP_USER}`
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('error getLookupInternalUser :: ', error);
    }
};

export const validateReserveFile = async (parameters) => {
    try {
        const fetchData = await fetch(
            ApiConstants.SERVICE_EVENT_VALIDATE_RESERVE_FILE,
            {
                method: 'POST',
                body: parameters,
                headers: {
                    'Accept-Language': 'th',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
            }
        );
        if (!fetchData.ok) {
            throw await fetchData.json();
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error validateReserveFile :: ', error);
        throw error;
    }
};

export const getLookupEventDetail = async (lookupName) => {
    try {
        // lookupName company, paths, departments
        const fetchData =
            lookupName === 'company'
                ? await fetchGet(ApiConstants.SERVICE_EVENT_GET_LOOKUP_COMPANY)
                : lookupName === 'paths'
                ? await fetchGet(ApiConstants.SERVICE_EVENT_GET_LOOKUP_PATH)
                : lookupName === 'departments'
                ? await fetchGet(ApiConstants.SERVICE_EVENT_GET_LOOKUP_DEP)
                : false;
        if (!fetchData.ok || !fetchData) {
            throw fetchData;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error getLookup error :: ', error);
    }
};

export const getLookupInternalUserEvent = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${ApiConstants.SERVICE_EVENT_GET_LOOKUP_USER}?${formatParameters(
                parameters
            )}`
        );
        if (!fetchData.ok) {
            throw fetchData;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error getLookupInternalUserEvent :: ', error);
    }
};

export const getLookupExternalUserEvent = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_EVENT_GET_LOOKUP_USER_EXTERNAL
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error getLookupExternalUserEvent :: ', error);
    }
};

export const getExternalUserEventByEmail = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_EVENT_GET_EXTERNAL_USER_EMAIL
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error getExternalUserEventByEmail :: ', error);
    }
};

export const postCheckinEventInternal = async (eventId, parameters) => {
    try {
        const fetchData = await fetch(
            ApiConstants.SERVICE_EVENT_POST_CHECKIN_EVENT_INTERNAL.replace(
                ':eventId',
                eventId
            ),
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'th',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
                body: JSON.stringify(parameters),
            }
        );
        if (!fetchData.ok) {
            throw await fetchData.json();
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error postCheckinEventInternal :: ', error);
        throw error;
    }
};

export const postCheckinEventExternal = async (eventId, parameters) => {
    try {
        const fetchData = await fetch(
            ApiConstants.SERVICE_EVENT_POST_CHECKIN_EVENT_EXTERNAL.replace(
                ':eventId',
                eventId
            ),
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'th',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
                body: JSON.stringify(parameters),
            }
        );
        if (!fetchData.ok) {
            throw await fetchData.json();
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error postCheckinEventInternal :: ', error);
        throw error;
    }
};

export const putEventCancel = async (eventId, parameters) => {
    try {
        const fetchData = await fetch(
            ApiConstants.SERVICE_EVENT_PUT_CANCEL_EVENT.replace(
                ':eventId',
                eventId
            ),
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'th',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
                body: JSON.stringify(parameters),
            }
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error putEventCancel :: ', error);
        throw error;
    }
};

export const putEventReserveCancel = async (eventId, reserveId, parameters) => {
    try {
        const fetchData = await fetch(
            ApiConstants.SERVICE_EVENT_PUT_CANCEL_RESERVE.replace(
                ':eventId',
                eventId
            ).replace(':reserveId', reserveId),
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'th',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
                body: JSON.stringify(parameters),
            }
        );
        if (!fetchData.ok) {
            throw await fetchData.json();
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error putEventReserveCancel :: ', error);
        throw error;
    }
};

export const getEventCheckinUser = async (eventId, parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_EVENT_GET_CHECKIN_USER
            }?${formatParametersSearchTable(parameters)}`.replace(
                ':eventId',
                eventId
            )
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('ex fetchEventSearch : ', error);
    }
};

export const exportEventSearch = async (userId, parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_EVENT_GET_EXPORT_EVENT_SEARCH
            }?${formatParametersSearchTable(parameters)}`.replace(
                ':userId',
                userId
            )
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.blob();
        return response;
    } catch (error) {
        console.log('ex exportEventSearch : ', error);
    }
};

export const exportEventCheckinSearch = async (eventId, parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_EVENT_GET_EXPORT_CHECKIN_USER
            }?${formatParameters(parameters)}`.replace(':eventId', eventId)
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.blob();
        return response;
    } catch (error) {
        console.log('ex exportEventCheckinSearch : ', error);
    }
};

export const reserveExternalUser = async (eventId, parameters) => {
    try {
        const fetchData = await fetch(
            ApiConstants.SERVICE_EVENT_RESERVE_USER_EXTERNAL.replace(
                ':eventId',
                eventId
            ),
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'th',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
                body: JSON.stringify(parameters),
            }
        );
        if (!fetchData.ok) {
            throw await fetchData.json();
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error reserveExternalUser :: ', error);
        throw error;
    }
};

export const getOptionEventSearchName = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_EVENT_GET_EVENT_SEARCH_NAME
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error getOptionEventSearchName :: ', error);
    }
};

export const getOptionUsersSearchEmployee = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_EVENT_GET_USERS_SEARCH_EMPLOYEE
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData;
        }
        const res = await fetchData.json();
        return res;
    } catch (error) {
        console.log('error getOptionUsersSearchEmployee :: ', error);
    }
};
